module.exports = __webpack_public_path__ + "img/user03.c1dde880.png";